import React, { ButtonHTMLAttributes, forwardRef } from 'react';
import styled from '@xstyled/styled-components';
import { t } from 'ttag';
import NextIcon from '~/assets/icons/next-btn-eds.svg';

const Button = styled.button`
  background: ${p => p.theme.colors.accentDark};
  padding: 8px 24px;
  height: 46px;
  border-radius: md;
  border: 1px solid var(--color-accent-edge);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  color: var(--color-on-accent);
  position: relative;
  margin: 0;
  cursor: pointer;
  text-align: center;
  font-variant-numeric: lining-nums proportional-nums;
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  white-space: nowrap;
  transition: background-color 0.15s ease;

  &:hover:not(:disabled) {
    background-color: color-mix(in srgb, var(--color-accent-dk) 70%, white);
  }

  &:active:not(:disabled) {
    background-color: color-mix(in srgb, var(--color-accent-dk) 70%, black);
  }

  &:focus {
    outline: 2px solid var(--color-focus-ring);
    outline-offset: 2px;
  }

  &:focus::after {
    content: '';
    display: block;
    position: absolute;
    border-radius: md;
    top: -2px;
    left: -2px;
    right: -2px;
    bottom: -2px;
    border: 2px solid var(--color-focus-ring-inner);
    pointer-events: none;
  }

  &:disabled {
    cursor: default;
  }

  /* @media ((max-width: 580px) and (max-height: 300px)) {
    padding: 4px 10px;
    width: fit-content;
    height: 28px;
    font-size: 12px;
    line-height: 16px;
    gap: 2px;

    > span {
      display: none;
    }
  } */
`;

const Next = styled(NextIcon)`
  display: block;
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  color: var(--color-on-accent);

  /* @media ((max-width: 580px) and (max-height: 300px)) {
    width: 16px;
    height: 16px;
  } */
`;

export const NextButtonEds = forwardRef<
  HTMLButtonElement,
  ButtonHTMLAttributes<HTMLButtonElement>
>(function NextButtonEds(props, ref) {
  return (
    <Button
      {...props}
      ref={ref}
      title={t`Next slide`}
      aria-label={t`Next slide`}
    >
      <span>{t`Next`}</span>
      <Next aria-hidden="true" focusable="false" />
    </Button>
  );
});
